import { useCallback, useMemo } from 'react';
import { useGetContainerStatusesByType } from 'api/containerStatuses';
import type { StatusRow, StatusType } from './StatusesTable.types';

export const useGetStatuses = () => {
  const { data, loading, getContainerStatusesByType } =
    useGetContainerStatusesByType();

  const rows: StatusRow[] | undefined = useMemo(
    () =>
      data?.map(({ id, name, type, color, enabled }) => ({
        id,
        type: type,
        name,
        color,
        enabled,
      })),
    [data],
  );

  const getStatuses = useCallback(
    (type: StatusType) => () => getContainerStatusesByType(type),
    [getContainerStatusesByType],
  );

  return { data: rows, loading, getStatuses };
};
